/**
 * Mobile Search Page Fix - Loaded only on /search page
 * Desktop: Uses native autofocus
 * Mobile: Removes autofocus, prevents focus loss on first tap to show keyboard
 */

(function() {
  'use strict';
  
  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
           || window.innerWidth <= 767;
  }
  
  function fixSearchInput() {
    const searchInput = document.querySelector('.js_iput_search, .t4s-search-form__input, input[name="q"]');
    if (!searchInput) return;
    
    // On mobile: remove autofocus and add focus handling
    if (isMobile()) {
      // Remove the autofocus attribute - it won't work on mobile anyway
      searchInput.removeAttribute('autofocus');
      
      // Fix all parent elements that might be blocking
      let parent = searchInput.parentElement;
      let depth = 0;
      while (parent && depth < 10) {
        parent.style.pointerEvents = 'auto';
        parent.style.touchAction = 'manipulation';
        parent = parent.parentElement;
        depth++;
      }
      
      // Fix the input itself
      searchInput.style.pointerEvents = 'auto';
      searchInput.style.touchAction = 'manipulation';
      searchInput.style.opacity = '1';
      searchInput.style.visibility = 'visible';
      searchInput.style.position = 'relative';
      searchInput.style.zIndex = '100';
      searchInput.style.webkitUserSelect = 'text';
      searchInput.style.userSelect = 'text';
      
      let isFocusing = false;
      
      // Prevent any other element from stealing focus
      const preventFocusSteal = function(e) {
        if (isFocusing && e.target !== searchInput && !searchInput.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      
      // Handle touch start - initiate focus
      searchInput.addEventListener('touchstart', function(e) {
        isFocusing = true;
        e.preventDefault();
        e.stopPropagation();
        searchInput.focus();
      }, { passive: false, capture: true });
      
      // Handle touch end - ensure keyboard shows
      searchInput.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        searchInput.focus();
        isFocusing = false;
      }, { passive: false, capture: true });
      
      // Handle touch move - keep focus
      searchInput.addEventListener('touchmove', function(e) {
        if (isFocusing) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, { passive: false, capture: true });
      
      // Handle focus to lock it in
      searchInput.addEventListener('focus', function(e) {
        e.preventDefault();
        e.stopPropagation();
        isFocusing = true;
      }, { capture: true });
      
      // Prevent blur on touch devices
      searchInput.addEventListener('blur', function(e) {
        // Only prevent blur if we're currently focusing (on touch)
        if (isFocusing && /touch/i.test(e.type)) {
          e.preventDefault();
          e.stopPropagation();
          searchInput.focus();
        }
        isFocusing = false;
      }, { passive: false, capture: true });
      
      // Prevent other elements from hijacking focus
      document.addEventListener('focusin', preventFocusSteal, { capture: true });
      
      // Handle click as well
      searchInput.addEventListener('click', function(e) {
        e.stopPropagation();
        searchInput.focus();
      }, { capture: true });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSearchInput);
  } else {
    fixSearchInput();
  }
  
  document.addEventListener('turbolinks:load', fixSearchInput);
  document.addEventListener('shopify:section:load', fixSearchInput);
})();
